import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {
  ApiController,
  ApiExecutor,
  ApiResponse,
  ApiValidationService,
  Body,
  GET,
  Header,
  Params,
  POST,
  PUT,
  Query,
} from '@app/core/api';

import {
  ForgotPasswordChangeDto,
  ForgotPasswordRequestDto,
  ForgotPasswordVerifyDto,
  PasswordLoginDto,
  SendOtpDto,
  VerifyOtpDto,
} from '../dto';
import {
  ForgotPasswordChangeResult,
  ForgotPasswordSendCodeResult,
  ForgotPasswordVerifyResult,
  PasswordLoginResult,
  SendOtpResult,
  TempRefCodeResult,
  VerifyOtpResult,
} from '../interfaces';

@ApiController('api/app/auth')
@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  constructor(
    public apiExecutor: ApiExecutor,
    public apiValidationService: ApiValidationService,
  ) {}

  @POST('/otp')
  sendOtp(@Body() dto: SendOtpDto): Observable<ApiResponse<SendOtpResult>> {
    return {} as Observable<ApiResponse<SendOtpResult>>;
  }

  @POST('/otp/verify')
  verifyOtp(@Body() dto: VerifyOtpDto): Observable<ApiResponse<VerifyOtpResult>> {
    return {} as Observable<ApiResponse<VerifyOtpResult>>;
  }

  @POST('/login/credentials')
  loginWithPassword(@Body() dto: PasswordLoginDto): Observable<ApiResponse<PasswordLoginResult>> {
    return {} as Observable<ApiResponse<PasswordLoginResult>>;
  }

  @POST('/password/recover/otp')
  sendForgotPasswordCode(@Body() dto: ForgotPasswordRequestDto): Observable<ApiResponse<ForgotPasswordSendCodeResult>> {
    return {} as Observable<ApiResponse<ForgotPasswordSendCodeResult>>;
  }

  @POST('/password/recover/otp/verify')
  verifyForgotPasswordCode(@Body() dto: ForgotPasswordVerifyDto): Observable<ApiResponse<ForgotPasswordVerifyResult>> {
    return {} as Observable<ApiResponse<ForgotPasswordVerifyResult>>;
  }

  @POST('/password/recover/change')
  changeForgotPassword(@Body() dto: ForgotPasswordChangeDto): Observable<ApiResponse<ForgotPasswordChangeResult>> {
    return {} as Observable<ApiResponse<ForgotPasswordChangeResult>>;
  }

  @GET('/refCode/:tref')
  getTempRefCode(@Params('tref') tref: string): Observable<ApiResponse<TempRefCodeResult>> {
    return {} as Observable<ApiResponse<TempRefCodeResult>>;
  }

  @GET('/existence-refCode')
  existenceRefCode(@Query('refCode') refCode: string): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }

  @PUT('/token')
  @Header({'Content-Type': 'application/json'})
  refreshAccessToken(@Body() refreshToken: string): Observable<ApiResponse<string>> {
    return {} as Observable<ApiResponse<string>>;
  }
}
